import { useEffect } from 'react';
import { useSendUXFEndedEvent } from 'UXF/hooks/useSendUXFEndedEvent';

import { EUnavailableType } from '../constants/unavailableType';
import { useUnavailableContent } from './useUnavailableContent';

export function useSendFeedback() {
    const { unavailableContentType } = useUnavailableContent();
    const sendUXFEndedEvent = useSendUXFEndedEvent();

    useEffect(() => {
        if (unavailableContentType === EUnavailableType.IS_OVER) {
            sendUXFEndedEvent();
        }
    }, [unavailableContentType]);
}
